/**
 * MapStyleControl — compact basemap style picker.
 */

import React, { useState } from 'react';
import type { BasemapStyle } from '../types/mapTypes';

interface MapStyleControlProps {
  current: BasemapStyle;
  onChange: (style: BasemapStyle) => void;
}

const STYLES: { key: BasemapStyle; label: string; icon: string }[] = [
  { key: 'streets', label: 'Streets', icon: '🛣️' },
  { key: 'satellite', label: 'Satellite', icon: '🛰️' },
  { key: 'satellite-labels', label: 'Sat + Labels', icon: '🗺️' },
  { key: 'terrain', label: 'Terrain', icon: '⛰️' },
];

export default function MapStyleControl({ current, onChange }: MapStyleControlProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        title="Change basemap"
        className="w-10 h-10 rounded-lg shadow-md bg-white text-slate-600 hover:bg-slate-50 flex items-center justify-center transition-colors"
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute top-12 right-0 w-36 bg-white rounded-lg shadow-lg border border-slate-200 overflow-hidden z-50">
          {STYLES.map((s) => (
            <button
              key={s.key}
              onClick={() => {
                onChange(s.key);
                setIsOpen(false);
              }}
              className={`w-full px-3 py-2 text-left text-sm flex items-center gap-2 transition-colors ${
                current === s.key
                  ? 'bg-emerald-50 text-emerald-700 font-semibold'
                  : 'hover:bg-slate-50 text-slate-600'
              }`}
            >
              <span className="text-base">{s.icon}</span>
              {s.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
